<template>
    <div class="trial-form-thank-you">
        <div class="trial-form-thank-you__left-side">
            <div class="trial-form-thank-you__inner-left">
                <h1 class="trial-form-thank-you__header-left" v-html="$t('FreeTrial.trial_header')"></h1>
                <img src="@/assets/images/trial-form.png" class="trial-form-thank-you__image" alt=""/>
                <ul class="trial-form-thank-you__list" v-for="i in 4">
                    <li v-html="$t(`FreeTrial.list_point_${i}`)"></li>
                </ul>
            </div>
        </div>
        <div class="trial-form-thank-you__inner-right">
            <span class="icon-checkmark trial-form-thank-you__icon"></span>
            <h1 class="trial-form-thank-you__header" v-html="thankYou.header"></h1>
            <span class="trial-form-thank-you__description" v-html="thankYou.description"></span>
            <span class="trial-form-thank-you__login" color="primary" @click="toggleLogin">{{ $t("Login.log_in") }}</span>
            <span class="trial-form-thank-you__note" v-html="thankYou.note"></span>
        </div>
    </div>
</template>

<script>
import LoginFormHelper from 'components/shared/mixins/loginFormHelper'

export default {
    name: 'trial-form-thank-you',
    mixins: [ LoginFormHelper ],
    data () {
        return {
            freeSubscriptionForm: {}
        }
    },
    computed: {
        isFormRegistration () {
            return this.freeSubscriptionForm && this.freeSubscriptionForm.type === 'registration'
        },
        isElisa () {
            return this.$route.params.slug === 'elisa'
        },
        thankYou () {
            if (this.isElisa) {
                return {
                    header: this.$t('FreeTrial.thank_you_header'),
                    description: this.$t('FreeTrial.thank_you_description_elisa'),
                    note: this.$t('FreeTrial.thank_you_note_elisa'),
                }
            }
            if (this.isFormRegistration) {
                return {
                    header: this.$t('FreeTrial.registration_thank_you_header'),
                    description: this.$t('FreeTrial.registration_thank_you_description'),
                    note: this.$t('FreeTrial.registration_thank_you_note')
                }
            }

            return {
                header: this.$t('FreeTrial.thank_you_header'),
                description: this.$t('FreeTrial.thank_you_description'),
                note: this.$t('FreeTrial.thank_you_note')
            }
        }
    },
    methods: {
        goToLogin () {
            this.$store.dispatch('User/toggleLoginBox')
        }
    },
    async created () {
        this.freeSubscriptionForm = await this.$store.dispatch('User/loadFreeSubscription', this.$route.params.slug)
    }
}
</script>

<style lang="scss" scoped>
    .trial-form-thank-you {
        display: flex;
        justify-content: center;
        padding: 145px 0 65px;

        &.app-content {
            [class*="desktop"] & {
                padding: 145px 0 65px;
                background: $white;
            }
        }

        &__inner-right {
            padding: 40px;
            display: flex;
            flex-direction: column;
            align-items: left;
            gap: 20px;
            background: $white;
            border-radius: 0 24px 24px 0;
            width: 740px;
        }

        &__inner-left {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }

        &__icon {
            font-size: 5rem;
            color: $shakespeare;
            margin: 0 auto;
        }

        &__header {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 3.2rem;
        }

        &__description {
            align-self: flex-start;
        }

        &__login {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 1.8rem;
            height: 41px;
            background: $lavender;
            color: $white;
            border-radius: 30px;
            line-height: 41px;
            cursor: pointer;
            text-align: center;
            margin: 10px 0;
            padding: 12px 25px;
            display: flex;
            align-items: center;
            width: max-content;

            &:hover {
                background: $dark_lavender;

            }
        }

        &__note {
            font-family: PlusJakartaSans-Italic, sans-serif;
            align-self: flex-start;
        }

        &__left-side {
            display: flex;
            padding: 30px;
            justify-content: center;
            background: $white;

            [class*="desktop"] & {
                border-radius: 24px 0 0 24px;
                width: 360px;
            }

            &.elisa {
                background: #0012b4;
            }
        }

        &__list {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 1.6rem;
            text-align: left;
            position: relative;

            & > li {
                margin: 0 0 20px 25px;

                &:before {
                    font-family: 'icomoon';
                    content: "\e925";
                    color: $lavender;
                    margin: 0 10px 0 0;
                    position: absolute;
                    left: 0;
                }
            }
        }

        &__image {
            margin: 0 0 30px;
            align-self: center;
        }


        &__header-left {
            font-family: PPAgrandir-Medium, sans-serif;
            color: $lavender;
            margin: 0 0 20px;
            text-align: center;
            font-size: 3.6rem;
        }
    }
</style>
